import { databasesStardogRequestDispatchers } from 'src/actions/databases/actionCreators';
import { DatabasesActionType } from 'src/actions/databases/actionTypes';
import { PublishProjectResponse } from 'src/actions/projects/actionCreators';
import { CreationType } from 'src/containers/PublishProjectDrawer/types';
import { DataSourcesState } from 'src/store/state/dataSources';
import * as copy from 'src/templates/copy';
import { PublishVirtualGraph } from 'src/utils/export/types';

export type PublishVirtualGraphResponse = PublishProjectResponse & {
  id: string;
  dataSource: string;
  projectVgId: string;
};

export const publishVirtualGraphs = async ({
  dataSources,
  databaseId,
  exports,
}: {
  dataSources: DataSourcesState;
  databaseId: string;
  exports: PublishVirtualGraph[];
}) => {
  const results: PublishVirtualGraphResponse[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const vgExport of exports) {
    const { id, dataSource, resourceName, files, properties, mappingInfo } =
      vgExport;
    const { mappingsOptions } = files;
    const mappings = mappingsOptions.contents;
    const isReplace = mappingInfo.creationType !== CreationType.NEW;
    const virtualGraphCopy = isReplace
      ? copy.notifications.publishProject.virtualGraph.replace
      : copy.notifications.publishProject.virtualGraph.create;

    const response =
      // eslint-disable-next-line no-await-in-loop
      await (isReplace
        ? databasesStardogRequestDispatchers.updateVirtualGraph({
            databaseId:
              dataSources.virtualGraphsById[id]?.database || databaseId,
            dataSource,
            mappings,
            properties,
            vgId: id,
          })
        : databasesStardogRequestDispatchers.createVirtualGraph({
            databaseId,
            dataSource,
            mappings,
            properties,
            vgId: id,
          }));

    const result: PublishVirtualGraphResponse =
      response.type === DatabasesActionType.CREATE_VIRTUAL_GRAPH_SUCCESS ||
      response.type === DatabasesActionType.UPDATE_VIRTUAL_GRAPH_SUCCESS
        ? {
            id,
            dataSource,
            projectVgId: mappingInfo.projectVgId,
            action: response,
            success: true,
            message: virtualGraphCopy.success(resourceName),
          }
        : {
            id,
            dataSource,
            projectVgId: mappingInfo.projectVgId,
            action: response,
            success: false,
            actionDescription: copy.notifications.database.importCsv,
            message: virtualGraphCopy.failure(resourceName),
          };
    results.push(result);
  }
  return results;
};
